// extracted by mini-css-extract-plugin
export var menu_list = "NavLinks-module--menu_list--4vOKN";